<!--
* 组件名 : 二级可展开列表
* 开发者 : JY
*
* 参数:
*   subMenuData     { Object } -  书籍数据
*
* 事件: null
*
*
-->

<template>
  <section class="sub-menus" ref="subMenus" v-html="content" />
</template>

<script>
export default {
  name: "sub-menus",
  props: {
    content: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.sub_menu_drawer();
  },
  methods: {
    sub_menu_drawer() {
      $(this.$refs.subMenus)
        .find(".dir>li")
        .append(
          `<button class="v-btn drawer-btn"><i class="material-icons-round">expand_more</i></button>`
        );

      $(".drawer-btn").on("click", (ev) => {
        let $el = $(ev.currentTarget);
        let $ul = $el.siblings(".secondDir");
        let height = 0;
        if (!$el.hasClass("active")) {
          height = $ul.get(0).scrollHeight;
          $ul.velocity({ height, opacity: 1 }).addClass("active");
          $el.addClass("active");
        } else {
          height = 0;
          $ul.velocity({ height, opacity: 0 }).removeClass("active");
          $el.removeClass("active");
        }
      });
    },
  },
};
</script>

<style lang="scss">
.sub-menus {
  margin-bottom: -50px;
  .dir {
    > li {
      padding-bottom: 16px;
      border-bottom: 1px solid rgba(#707070, 0.08);
      position: relative;

      &:nth-of-type(n + 2) {
        padding-top: 16px;

        .v-btn {
          top: 8px;
        }
      }

      &:last-of-type {
        border: 0;
      }

      .v-btn {
        position: absolute;
        right: 0;
        top: -6px;
        transition: transform 0.5s ease;
        &.active {
          transform: rotate(180deg);
        }
      }
    }

    .secondDir {
      height: 0px;
      overflow: hidden;
      display: flex;
      flex-wrap: wrap;

      > li {
        margin-top: 24px;
        width: 50%;
      }
    }

    .secondTitle {
      font-size: 18px;
      font-weight: 700;
      display: block;
      margin-bottom: 8px;
      padding-right: 46px;
    }

    .secondPeriod {
      font-size: 14px;
      color: #57636d;
    }
  }
}

body.latin {
  .sub-menus {
    .dir .secondDir > li {
      width: 100%;
    }
  }
}
</style>
